// extracted by mini-css-extract-plugin
module.exports = {"date":"Date_date__1aR4l"};